import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const UniversalSubtitlesIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3820_26323)">
      <path
        d="M49.0833 56.8334H12.9167C9.49221 56.8293 6.20919 55.4671 3.78773 53.0457C1.36628 50.6242 0.00410197 47.3412 0 43.9168L0 18.0834C0.00410197 14.659 1.36628 11.3759 3.78773 8.95448C6.20919 6.53303 9.49221 5.17085 12.9167 5.16675H49.0833C52.5078 5.17085 55.7908 6.53303 58.2123 8.95448C60.6337 11.3759 61.9959 14.659 62 18.0834V43.9168C61.9959 47.3412 60.6337 50.6242 58.2123 53.0457C55.7908 55.4671 52.5078 56.8293 49.0833 56.8334ZM12.9167 10.3334C10.8612 10.3334 8.89 11.1499 7.43659 12.6033C5.98318 14.0567 5.16667 16.028 5.16667 18.0834V43.9168C5.16667 45.9722 5.98318 47.9434 7.43659 49.3968C8.89 50.8502 10.8612 51.6668 12.9167 51.6668H49.0833C51.1388 51.6668 53.11 50.8502 54.5634 49.3968C56.0168 47.9434 56.8333 45.9722 56.8333 43.9168V18.0834C56.8333 16.028 56.0168 14.0567 54.5634 12.6033C53.11 11.1499 51.1388 10.3334 49.0833 10.3334H12.9167Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M49.084 33.5834H28.4173C27.7322 33.5834 27.0751 33.3112 26.5906 32.8268C26.1062 32.3423 25.834 31.6852 25.834 31.0001C25.834 30.3149 26.1062 29.6579 26.5906 29.1734C27.0751 28.6889 27.7322 28.4167 28.4173 28.4167H49.084C49.7691 28.4167 50.4262 28.6889 50.9107 29.1734C51.3951 29.6579 51.6673 30.3149 51.6673 31.0001C51.6673 31.6852 51.3951 32.3423 50.9107 32.8268C50.4262 33.3112 49.7691 33.5834 49.084 33.5834Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M18.084 33.5834H12.9173C12.2322 33.5834 11.5751 33.3112 11.0906 32.8268C10.6062 32.3423 10.334 31.6852 10.334 31.0001C10.334 30.3149 10.6062 29.6579 11.0906 29.1734C11.5751 28.6889 12.2322 28.4167 12.9173 28.4167H18.084C18.7691 28.4167 19.4262 28.6889 19.9107 29.1734C20.3951 29.6579 20.6673 30.3149 20.6673 31.0001C20.6673 31.6852 20.3951 32.3423 19.9107 32.8268C19.4262 33.3112 18.7691 33.5834 18.084 33.5834Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M33.584 46.4999H12.9173C12.2322 46.4999 11.5751 46.2277 11.0906 45.7433C10.6062 45.2588 10.334 44.6017 10.334 43.9166C10.334 43.2314 10.6062 42.5744 11.0906 42.0899C11.5751 41.6054 12.2322 41.3333 12.9173 41.3333H33.584C34.2691 41.3333 34.9262 41.6054 35.4107 42.0899C35.8951 42.5744 36.1673 43.2314 36.1673 43.9166C36.1673 44.6017 35.8951 45.2588 35.4107 45.7433C34.9262 46.2277 34.2691 46.4999 33.584 46.4999Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
      <path
        d="M49.084 46.4999H43.9173C43.2322 46.4999 42.5751 46.2277 42.0906 45.7433C41.6062 45.2588 41.334 44.6017 41.334 43.9166C41.334 43.2314 41.6062 42.5744 42.0906 42.0899C42.5751 41.6054 43.2322 41.3333 43.9173 41.3333H49.084C49.7691 41.3333 50.4262 41.6054 50.9107 42.0899C51.3951 42.5744 51.6673 43.2314 51.6673 43.9166C51.6673 44.6017 51.3951 45.2588 50.9107 45.7433C50.4262 46.2277 49.7691 46.4999 49.084 46.4999Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
    </g>
    <defs>
      <clipPath id="clip0_3820_26323">
        <rect width="62" height="62" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
